/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .arrow {
    fill: ${theme.color.mainBg}
  }
  .bg {
    fill: ${theme.color.modalSubBg2}
  }
`
export default class ResetIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" css={Color}>
        <g id="reset" transform="translate(-108 -586)">
          <circle id="bg" className="bg" cx="12" cy="12" r="12" transform="translate(108 586)" fill="#d5d5d5"/>
          <g id="arrow" transform="translate(115.199 592.9)">
            <path id="합치기_146" className="arrow" data-name="합치기 146" d="M-2095.552-11119.324a5.208,5.208,0,0,1-3.181-2.422.779.779,0,0,1-.081-.6.776.776,0,0,1,.369-.483l.008,0a.776.776,0,0,1,.391-.1.79.79,0,0,1,.684.394,3.632,3.632,0,0,0,2.212,1.685,3.579,3.579,0,0,0,.927.123,3.616,3.616,0,0,0,1.83-.5l.028-.017a3.653,3.653,0,0,0,1.288-4.953,3.657,3.657,0,0,0-3.148-1.8,3.636,3.636,0,0,0-1.821.492,3.572,3.572,0,0,0-.9.751l1.715-.039.009,0a.745.745,0,0,1,.74.721.749.749,0,0,1-.724.76l-3.184.069a.743.743,0,0,1-.74-.723l-.073-3.168a.739.739,0,0,1,.207-.525.726.726,0,0,1,.517-.229h.025a.761.761,0,0,1,.735.724l.02.966a4.7,4.7,0,0,1,.858-.662,5.243,5.243,0,0,1,2.623-.709,5.247,5.247,0,0,1,4.517,2.592,5.2,5.2,0,0,1,.536,3.911,5.2,5.2,0,0,1-2.352,3.17l-.235.132a5.2,5.2,0,0,1-2.464.625A5.311,5.311,0,0,1-2095.552-11119.324Z" transform="translate(2099.049 11129.75)" fill="#1c202b"/>
          </g>
        </g>
      </svg>
    )
  }
}
